import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `DateTime` scalar type represents a date and time with time zone offset information. */
  DateTime: { input: string; output: string; }
  /** The `Decimal` scalar type represents a decimal floating-point number with high precision. */
  Decimal: { input: number; output: number; }
  /** The `LocalDate` scalar type represents a date without time or time zone information. */
  LocalDate: { input: string; output: string; }
  /** The `Long` scalar type represents a signed 64-bit integer. */
  Long: { input: any; output: any; }
  /** The `UUID` scalar type represents a Universally Unique Identifier (UUID) as defined by RFC 9562. */
  UUID: { input: any; output: any; }
  /** The `UnsignedByte` scalar type represents an unsigned 8-bit integer. */
  UnsignedByte: { input: any; output: any; }
};

export enum AccountStatus {
  EntraConnected = 'ENTRA_CONNECTED',
  EntraDisabled = 'ENTRA_DISABLED',
  EntraInvited = 'ENTRA_INVITED',
  MagicLink = 'MAGIC_LINK'
}

export type AccountStatusOperationFilterInput = {
  eq?: InputMaybe<AccountStatus>;
  in?: InputMaybe<Array<AccountStatus>>;
  neq?: InputMaybe<AccountStatus>;
  nin?: InputMaybe<Array<AccountStatus>>;
};

export type Adresse = {
  __typename?: 'Adresse';
  adresse1?: Maybe<Scalars['String']['output']>;
  adresse2?: Maybe<Scalars['String']['output']>;
  adresse3?: Maybe<Scalars['String']['output']>;
  arianeId?: Maybe<Scalars['Long']['output']>;
  cedex?: Maybe<Scalars['String']['output']>;
  codePostalCode?: Maybe<Scalars['String']['output']>;
  complement?: Maybe<Scalars['String']['output']>;
  consultantStatutJuridiques: Array<ConsultantStatutJuridique>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate: Scalars['DateTime']['output'];
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  modeLogement?: Maybe<Scalars['String']['output']>;
  noteId?: Maybe<Scalars['Long']['output']>;
  paysCode?: Maybe<Scalars['String']['output']>;
  paysCodeNavigation?: Maybe<Pays>;
  personnePhysiqueAdresses: Array<PersonnePhysiqueAdresse>;
  typeAdresseCode: Scalars['String']['output'];
  villeNom?: Maybe<Scalars['String']['output']>;
};

export type AdresseFilterInput = {
  adresse1?: InputMaybe<StringOperationFilterInput>;
  adresse2?: InputMaybe<StringOperationFilterInput>;
  adresse3?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<AdresseFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  cedex?: InputMaybe<StringOperationFilterInput>;
  codePostalCode?: InputMaybe<StringOperationFilterInput>;
  complement?: InputMaybe<StringOperationFilterInput>;
  consultantStatutJuridiques?: InputMaybe<ListFilterInputTypeOfConsultantStatutJuridiqueFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  modeLogement?: InputMaybe<StringOperationFilterInput>;
  noteId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<AdresseFilterInput>>;
  paysCode?: InputMaybe<StringOperationFilterInput>;
  paysCodeNavigation?: InputMaybe<PaysFilterInput>;
  personnePhysiqueAdresses?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueAdresseFilterInput>;
  typeAdresseCode?: InputMaybe<StringOperationFilterInput>;
  villeNom?: InputMaybe<StringOperationFilterInput>;
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

export type AtlasInvestisseur = {
  __typename?: 'AtlasInvestisseur';
  arianeId?: Maybe<Scalars['Long']['output']>;
  code: Scalars['String']['output'];
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateConnaissance?: Maybe<Scalars['LocalDate']['output']>;
  dateDernierScanAccuity?: Maybe<Scalars['LocalDate']['output']>;
  dateEntreeRelation?: Maybe<Scalars['LocalDate']['output']>;
  dateMajScanAccuityRequis?: Maybe<Scalars['LocalDate']['output']>;
  dateSuppression?: Maybe<Scalars['DateTime']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  gdaBackOffice?: Maybe<Scalars['Boolean']['output']>;
  gerePar: Scalars['Int']['output'];
  id: Scalars['Long']['output'];
  idSourceAramis?: Maybe<Scalars['String']['output']>;
  idSourceDiapason?: Maybe<Scalars['String']['output']>;
  inverseRecommandePar: Array<AtlasInvestisseur>;
  investisseurConsultants: Array<InvestisseurConsultant>;
  investisseurPersonnePhysiques: Array<InvestisseurPersonnePhysique>;
  logiqueSuppression?: Maybe<Scalars['Boolean']['output']>;
  modeCommunication?: Maybe<Scalars['String']['output']>;
  objectifMontantEpargneMensuel?: Maybe<Scalars['Decimal']['output']>;
  objectifMontantEpargnePrecaution?: Maybe<Scalars['Decimal']['output']>;
  origineContactCode?: Maybe<Scalars['String']['output']>;
  origineSaisie?: Maybe<Scalars['UnsignedByte']['output']>;
  ppeBackOffice?: Maybe<Scalars['Boolean']['output']>;
  recommandePar?: Maybe<AtlasInvestisseur>;
  recommandeParId?: Maybe<Scalars['Long']['output']>;
  recommandeParNom?: Maybe<Scalars['String']['output']>;
  scanAccuityRequis?: Maybe<Scalars['Boolean']['output']>;
  statutCode: Scalars['String']['output'];
};

export type AtlasInvestisseurFilterInput = {
  and?: InputMaybe<Array<AtlasInvestisseurFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateConnaissance?: InputMaybe<LocalDateOperationFilterInput>;
  dateDernierScanAccuity?: InputMaybe<LocalDateOperationFilterInput>;
  dateEntreeRelation?: InputMaybe<LocalDateOperationFilterInput>;
  dateMajScanAccuityRequis?: InputMaybe<LocalDateOperationFilterInput>;
  dateSuppression?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  gdaBackOffice?: InputMaybe<BooleanOperationFilterInput>;
  gerePar?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSourceAramis?: InputMaybe<StringOperationFilterInput>;
  idSourceDiapason?: InputMaybe<StringOperationFilterInput>;
  inverseRecommandePar?: InputMaybe<ListFilterInputTypeOfAtlasInvestisseurFilterInput>;
  investisseurConsultants?: InputMaybe<ListFilterInputTypeOfInvestisseurConsultantFilterInput>;
  investisseurPersonnePhysiques?: InputMaybe<ListFilterInputTypeOfInvestisseurPersonnePhysiqueFilterInput>;
  logiqueSuppression?: InputMaybe<BooleanOperationFilterInput>;
  modeCommunication?: InputMaybe<StringOperationFilterInput>;
  objectifMontantEpargneMensuel?: InputMaybe<DecimalOperationFilterInput>;
  objectifMontantEpargnePrecaution?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<AtlasInvestisseurFilterInput>>;
  origineContactCode?: InputMaybe<StringOperationFilterInput>;
  origineSaisie?: InputMaybe<UnsignedByteOperationFilterInput>;
  ppeBackOffice?: InputMaybe<BooleanOperationFilterInput>;
  recommandePar?: InputMaybe<AtlasInvestisseurFilterInput>;
  recommandeParId?: InputMaybe<LongOperationFilterInput>;
  recommandeParNom?: InputMaybe<StringOperationFilterInput>;
  scanAccuityRequis?: InputMaybe<BooleanOperationFilterInput>;
  statutCode?: InputMaybe<StringOperationFilterInput>;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkCreateDocumentRequestsOutput = {
  __typename?: 'BulkCreateDocumentRequestsOutput';
  derUploadUrl?: Maybe<Scalars['String']['output']>;
  errors: Array<InvestisseurErrorOutput>;
};

export type Consultant = {
  __typename?: 'Consultant';
  affiliationDate?: Maybe<Scalars['DateTime']['output']>;
  arianeId?: Maybe<Scalars['Long']['output']>;
  code: Scalars['String']['output'];
  codeTier?: Maybe<Scalars['String']['output']>;
  commentairePeriodeJunior?: Maybe<Scalars['String']['output']>;
  consultantHabilitations: Array<ConsultantHabilitation>;
  consultantPersonnePhysiques: Array<ConsultantPersonnePhysique>;
  consultantStatutJuridiques: Array<ConsultantStatutJuridique>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate: Scalars['DateTime']['output'];
  date1AcquisitionDroit?: Maybe<Scalars['DateTime']['output']>;
  date1Manager?: Maybe<Scalars['DateTime']['output']>;
  date1VenteActee?: Maybe<Scalars['DateTime']['output']>;
  date1VenteFinancement?: Maybe<Scalars['DateTime']['output']>;
  date1VenteImmo?: Maybe<Scalars['DateTime']['output']>;
  date1VentePlacement?: Maybe<Scalars['DateTime']['output']>;
  dateAcquisitionDroit?: Maybe<Scalars['DateTime']['output']>;
  dateAffiliationProdemial?: Maybe<Scalars['DateTime']['output']>;
  dateContact?: Maybe<Scalars['DateTime']['output']>;
  dateDemission?: Maybe<Scalars['DateTime']['output']>;
  dateEntree?: Maybe<Scalars['DateTime']['output']>;
  dateFinPeriodeJunior?: Maybe<Scalars['DateTime']['output']>;
  dateFinValiditeAffiliation?: Maybe<Scalars['DateTime']['output']>;
  dateSeminairePro?: Maybe<Scalars['DateTime']['output']>;
  derniereDateExclusif?: Maybe<Scalars['DateTime']['output']>;
  derniereDateNonExclusif?: Maybe<Scalars['DateTime']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  eligilibleRenouvellement: Scalars['Boolean']['output'];
  exclusif: Scalars['Boolean']['output'];
  galaxy?: Maybe<Consultant>;
  galaxyId?: Maybe<Scalars['Long']['output']>;
  gerePar: Scalars['Int']['output'];
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  inverseGalaxy: Array<Consultant>;
  inverseManager: Array<Consultant>;
  inverseParrain: Array<Consultant>;
  inverseTeteReseau: Array<Consultant>;
  investisseurConsultants: Array<InvestisseurConsultant>;
  manager?: Maybe<Consultant>;
  managerId?: Maybe<Scalars['Long']['output']>;
  mandatAutofacFinancement?: Maybe<Scalars['UnsignedByte']['output']>;
  mandatAutofacPlacement?: Maybe<Scalars['UnsignedByte']['output']>;
  mandatAutofacTotal?: Maybe<Scalars['UnsignedByte']['output']>;
  motifResiliationCode?: Maybe<Scalars['String']['output']>;
  nbAmbassadeurs?: Maybe<Scalars['UnsignedByte']['output']>;
  nbRecommandations?: Maybe<Scalars['UnsignedByte']['output']>;
  origineSaisie: Scalars['UnsignedByte']['output'];
  parrain?: Maybe<Consultant>;
  parrainId?: Maybe<Scalars['Long']['output']>;
  peutParainner?: Maybe<Scalars['Boolean']['output']>;
  qualificationCode?: Maybe<Scalars['String']['output']>;
  qualificationOfficielleCode?: Maybe<Scalars['String']['output']>;
  raisonSociale?: Maybe<Scalars['String']['output']>;
  reponseRenouvellement?: Maybe<Scalars['UnsignedByte']['output']>;
  resiliationDate?: Maybe<Scalars['DateTime']['output']>;
  souhaiteCollaborerAvecStelliumFi?: Maybe<Scalars['Boolean']['output']>;
  statutCode: Scalars['String']['output'];
  tauxRemuneration?: Maybe<Scalars['Decimal']['output']>;
  tauxRemunerationOfficiel?: Maybe<Scalars['Decimal']['output']>;
  teteReseau?: Maybe<Consultant>;
  teteReseauId?: Maybe<Scalars['Long']['output']>;
  titreCode?: Maybe<Scalars['String']['output']>;
  totalDebours?: Maybe<Scalars['Decimal']['output']>;
};

export type ConsultantDer = {
  __typename?: 'ConsultantDer';
  consultantCode: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  investisseurs: Array<Investisseur>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ConsultantDerFilterInput = {
  and?: InputMaybe<Array<ConsultantDerFilterInput>>;
  consultantCode?: InputMaybe<StringOperationFilterInput>;
  documentId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  investisseurs?: InputMaybe<ListFilterInputTypeOfInvestisseurFilterInput>;
  or?: InputMaybe<Array<ConsultantDerFilterInput>>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type ConsultantDerSortInput = {
  consultantCode?: InputMaybe<SortEnumType>;
  documentId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type ConsultantFilterInput = {
  affiliationDate?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<ConsultantFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  codeTier?: InputMaybe<StringOperationFilterInput>;
  commentairePeriodeJunior?: InputMaybe<StringOperationFilterInput>;
  consultantHabilitations?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationFilterInput>;
  consultantPersonnePhysiques?: InputMaybe<ListFilterInputTypeOfConsultantPersonnePhysiqueFilterInput>;
  consultantStatutJuridiques?: InputMaybe<ListFilterInputTypeOfConsultantStatutJuridiqueFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  date1AcquisitionDroit?: InputMaybe<DateTimeOperationFilterInput>;
  date1Manager?: InputMaybe<DateTimeOperationFilterInput>;
  date1VenteActee?: InputMaybe<DateTimeOperationFilterInput>;
  date1VenteFinancement?: InputMaybe<DateTimeOperationFilterInput>;
  date1VenteImmo?: InputMaybe<DateTimeOperationFilterInput>;
  date1VentePlacement?: InputMaybe<DateTimeOperationFilterInput>;
  dateAcquisitionDroit?: InputMaybe<DateTimeOperationFilterInput>;
  dateAffiliationProdemial?: InputMaybe<DateTimeOperationFilterInput>;
  dateContact?: InputMaybe<DateTimeOperationFilterInput>;
  dateDemission?: InputMaybe<DateTimeOperationFilterInput>;
  dateEntree?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinPeriodeJunior?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinValiditeAffiliation?: InputMaybe<DateTimeOperationFilterInput>;
  dateSeminairePro?: InputMaybe<DateTimeOperationFilterInput>;
  derniereDateExclusif?: InputMaybe<DateTimeOperationFilterInput>;
  derniereDateNonExclusif?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  eligilibleRenouvellement?: InputMaybe<BooleanOperationFilterInput>;
  exclusif?: InputMaybe<BooleanOperationFilterInput>;
  galaxy?: InputMaybe<ConsultantFilterInput>;
  galaxyId?: InputMaybe<LongOperationFilterInput>;
  gerePar?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  inverseGalaxy?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  inverseManager?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  inverseParrain?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  inverseTeteReseau?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  investisseurConsultants?: InputMaybe<ListFilterInputTypeOfInvestisseurConsultantFilterInput>;
  manager?: InputMaybe<ConsultantFilterInput>;
  managerId?: InputMaybe<LongOperationFilterInput>;
  mandatAutofacFinancement?: InputMaybe<UnsignedByteOperationFilterInput>;
  mandatAutofacPlacement?: InputMaybe<UnsignedByteOperationFilterInput>;
  mandatAutofacTotal?: InputMaybe<UnsignedByteOperationFilterInput>;
  motifResiliationCode?: InputMaybe<StringOperationFilterInput>;
  nbAmbassadeurs?: InputMaybe<UnsignedByteOperationFilterInput>;
  nbRecommandations?: InputMaybe<UnsignedByteOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantFilterInput>>;
  origineSaisie?: InputMaybe<UnsignedByteOperationFilterInput>;
  parrain?: InputMaybe<ConsultantFilterInput>;
  parrainId?: InputMaybe<LongOperationFilterInput>;
  peutParainner?: InputMaybe<BooleanOperationFilterInput>;
  qualificationCode?: InputMaybe<StringOperationFilterInput>;
  qualificationOfficielleCode?: InputMaybe<StringOperationFilterInput>;
  raisonSociale?: InputMaybe<StringOperationFilterInput>;
  reponseRenouvellement?: InputMaybe<UnsignedByteOperationFilterInput>;
  resiliationDate?: InputMaybe<DateTimeOperationFilterInput>;
  souhaiteCollaborerAvecStelliumFi?: InputMaybe<BooleanOperationFilterInput>;
  statutCode?: InputMaybe<StringOperationFilterInput>;
  tauxRemuneration?: InputMaybe<DecimalOperationFilterInput>;
  tauxRemunerationOfficiel?: InputMaybe<DecimalOperationFilterInput>;
  teteReseau?: InputMaybe<ConsultantFilterInput>;
  teteReseauId?: InputMaybe<LongOperationFilterInput>;
  titreCode?: InputMaybe<StringOperationFilterInput>;
  totalDebours?: InputMaybe<DecimalOperationFilterInput>;
};

export type ConsultantHabilitation = {
  __typename?: 'ConsultantHabilitation';
  codeHabilitation?: Maybe<Scalars['String']['output']>;
  consultant?: Maybe<Consultant>;
  consultantHabilitationInscriptions: Array<ConsultantHabilitationInscription>;
  consultantId?: Maybe<Scalars['Long']['output']>;
  dateDebut?: Maybe<Scalars['DateTime']['output']>;
  dateFin?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  statut?: Maybe<Scalars['Int']['output']>;
};

export type ConsultantHabilitationFilterInput = {
  and?: InputMaybe<Array<ConsultantHabilitationFilterInput>>;
  codeHabilitation?: InputMaybe<StringOperationFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantHabilitationInscriptions?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationInscriptionFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  dateDebut?: InputMaybe<DateTimeOperationFilterInput>;
  dateFin?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationFilterInput>>;
  statut?: InputMaybe<IntOperationFilterInput>;
};

export type ConsultantHabilitationInscription = {
  __typename?: 'ConsultantHabilitationInscription';
  consultantHabilitation?: Maybe<ConsultantHabilitation>;
  consultantHabilitationId?: Maybe<Scalars['Long']['output']>;
  dateDebut?: Maybe<Scalars['DateTime']['output']>;
  dateFin?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  numeroInscription?: Maybe<Scalars['String']['output']>;
};

export type ConsultantHabilitationInscriptionFilterInput = {
  and?: InputMaybe<Array<ConsultantHabilitationInscriptionFilterInput>>;
  consultantHabilitation?: InputMaybe<ConsultantHabilitationFilterInput>;
  consultantHabilitationId?: InputMaybe<LongOperationFilterInput>;
  dateDebut?: InputMaybe<DateTimeOperationFilterInput>;
  dateFin?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  numeroInscription?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationInscriptionFilterInput>>;
};

export type ConsultantPersonnePhysique = {
  __typename?: 'ConsultantPersonnePhysique';
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  personnePhysique: PersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
};

export type ConsultantPersonnePhysiqueFilterInput = {
  and?: InputMaybe<Array<ConsultantPersonnePhysiqueFilterInput>>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantPersonnePhysiqueFilterInput>>;
  personnePhysique?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
};

export type ConsultantStatutJuridique = {
  __typename?: 'ConsultantStatutJuridique';
  actif: Scalars['Boolean']['output'];
  adressePro: Adresse;
  adresseProId: Scalars['Long']['output'];
  assujettiTVACode?: Maybe<Scalars['String']['output']>;
  codeTier?: Maybe<Scalars['String']['output']>;
  commissionDifferenceImmo: Scalars['Boolean']['output'];
  commissionDifferencePlacement: Scalars['Boolean']['output'];
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateAttest3558?: Maybe<Scalars['DateTime']['output']>;
  dateAttestHonneur?: Maybe<Scalars['DateTime']['output']>;
  dateAttestKbisPerso?: Maybe<Scalars['DateTime']['output']>;
  dateAttestUrssafSociete?: Maybe<Scalars['DateTime']['output']>;
  dateKBISOriginal?: Maybe<Scalars['DateTime']['output']>;
  dateUrssafPer?: Maybe<Scalars['DateTime']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  etatStatutCode: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  nomCommercial?: Maybe<Scalars['String']['output']>;
  numeroTva?: Maybe<Scalars['String']['output']>;
  raisonSociale?: Maybe<Scalars['String']['output']>;
  siret?: Maybe<Scalars['String']['output']>;
  statutJuridiqueCode: Scalars['String']['output'];
  typeSocieteCode?: Maybe<Scalars['String']['output']>;
  villeSiret?: Maybe<Scalars['String']['output']>;
};

export type ConsultantStatutJuridiqueFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  adressePro?: InputMaybe<AdresseFilterInput>;
  adresseProId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<ConsultantStatutJuridiqueFilterInput>>;
  assujettiTVACode?: InputMaybe<StringOperationFilterInput>;
  codeTier?: InputMaybe<StringOperationFilterInput>;
  commissionDifferenceImmo?: InputMaybe<BooleanOperationFilterInput>;
  commissionDifferencePlacement?: InputMaybe<BooleanOperationFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateAttest3558?: InputMaybe<DateTimeOperationFilterInput>;
  dateAttestHonneur?: InputMaybe<DateTimeOperationFilterInput>;
  dateAttestKbisPerso?: InputMaybe<DateTimeOperationFilterInput>;
  dateAttestUrssafSociete?: InputMaybe<DateTimeOperationFilterInput>;
  dateKBISOriginal?: InputMaybe<DateTimeOperationFilterInput>;
  dateUrssafPer?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  etatStatutCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  nomCommercial?: InputMaybe<StringOperationFilterInput>;
  numeroTva?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantStatutJuridiqueFilterInput>>;
  raisonSociale?: InputMaybe<StringOperationFilterInput>;
  siret?: InputMaybe<StringOperationFilterInput>;
  statutJuridiqueCode?: InputMaybe<StringOperationFilterInput>;
  typeSocieteCode?: InputMaybe<StringOperationFilterInput>;
  villeSiret?: InputMaybe<StringOperationFilterInput>;
};

export type Contrat = {
  __typename?: 'Contrat';
  clauseBeneficiaire?: Maybe<Scalars['String']['output']>;
  codeEtatContrat?: Maybe<Scalars['String']['output']>;
  codeModeGestion?: Maybe<Scalars['String']['output']>;
  contratsInvestisseurs?: Maybe<Array<ContratsInvestisseur>>;
  contratsSupports?: Maybe<Array<ContratsSupport>>;
  cumulRachats?: Maybe<Scalars['Decimal']['output']>;
  cumulVersementsBruts?: Maybe<Scalars['Decimal']['output']>;
  cumulVersementsLibresBruts?: Maybe<Scalars['Decimal']['output']>;
  cumulVersementsLibresNets?: Maybe<Scalars['Decimal']['output']>;
  cumulVersementsNets?: Maybe<Scalars['Decimal']['output']>;
  cumulVpBruts?: Maybe<Scalars['Decimal']['output']>;
  cumulVpNets?: Maybe<Scalars['Decimal']['output']>;
  dateDebutContrat?: Maybe<Scalars['LocalDate']['output']>;
  dateDernierVp?: Maybe<Scalars['LocalDate']['output']>;
  dateFinContrat?: Maybe<Scalars['LocalDate']['output']>;
  dateValorisation?: Maybe<Scalars['LocalDate']['output']>;
  epargneSecurisee?: Maybe<Scalars['Decimal']['output']>;
  flagEpargneHandicap?: Maybe<Scalars['Boolean']['output']>;
  flagNantissement?: Maybe<Scalars['Boolean']['output']>;
  flagRpp?: Maybe<Scalars['Boolean']['output']>;
  flagVp?: Maybe<Scalars['Boolean']['output']>;
  idContrat: Scalars['String']['output'];
  idPartenaire: Scalars['String']['output'];
  modeGestion?: Maybe<ModeGestion>;
  numeroContrat?: Maybe<Scalars['String']['output']>;
  perfPlusMoinsValueFinanciereBrute?: Maybe<Scalars['Decimal']['output']>;
  perfPlusMoinsValueFinanciereNette?: Maybe<Scalars['Decimal']['output']>;
  periodiciteVp?: Maybe<PeriodiciteVp>;
  produit?: Maybe<Produit>;
  refIdProduit?: Maybe<Scalars['String']['output']>;
  rppDatedebut?: Maybe<Scalars['LocalDate']['output']>;
  rppMontantUnitaire?: Maybe<Scalars['Decimal']['output']>;
  rppPeriodicite?: Maybe<Scalars['String']['output']>;
  valorisation?: Maybe<Scalars['Decimal']['output']>;
  versementInitialBrut?: Maybe<Scalars['Decimal']['output']>;
  versementInitialNet?: Maybe<Scalars['Decimal']['output']>;
  vpDateDebut?: Maybe<Scalars['LocalDate']['output']>;
  vpDuree?: Maybe<Scalars['Int']['output']>;
  vpMontantUnitaire?: Maybe<Scalars['Decimal']['output']>;
  vpPeriodicite?: Maybe<Scalars['String']['output']>;
};

export type ContratFilterInput = {
  and?: InputMaybe<Array<ContratFilterInput>>;
  clauseBeneficiaire?: InputMaybe<StringOperationFilterInput>;
  codeEtatContrat?: InputMaybe<StringOperationFilterInput>;
  codeModeGestion?: InputMaybe<StringOperationFilterInput>;
  contratsInvestisseurs?: InputMaybe<ListFilterInputTypeOfContratsInvestisseurFilterInput>;
  contratsSupports?: InputMaybe<ListFilterInputTypeOfContratsSupportFilterInput>;
  cumulRachats?: InputMaybe<DecimalOperationFilterInput>;
  cumulVersementsBruts?: InputMaybe<DecimalOperationFilterInput>;
  cumulVersementsLibresBruts?: InputMaybe<DecimalOperationFilterInput>;
  cumulVersementsLibresNets?: InputMaybe<DecimalOperationFilterInput>;
  cumulVersementsNets?: InputMaybe<DecimalOperationFilterInput>;
  cumulVpBruts?: InputMaybe<DecimalOperationFilterInput>;
  cumulVpNets?: InputMaybe<DecimalOperationFilterInput>;
  dateDebutContrat?: InputMaybe<LocalDateOperationFilterInput>;
  dateDernierVp?: InputMaybe<LocalDateOperationFilterInput>;
  dateFinContrat?: InputMaybe<LocalDateOperationFilterInput>;
  dateValorisation?: InputMaybe<LocalDateOperationFilterInput>;
  epargneSecurisee?: InputMaybe<DecimalOperationFilterInput>;
  flagEpargneHandicap?: InputMaybe<BooleanOperationFilterInput>;
  flagNantissement?: InputMaybe<BooleanOperationFilterInput>;
  flagRpp?: InputMaybe<BooleanOperationFilterInput>;
  flagVp?: InputMaybe<BooleanOperationFilterInput>;
  idContrat?: InputMaybe<StringOperationFilterInput>;
  idPartenaire?: InputMaybe<StringOperationFilterInput>;
  modeGestion?: InputMaybe<ModeGestionFilterInput>;
  numeroContrat?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ContratFilterInput>>;
  perfPlusMoinsValueFinanciereBrute?: InputMaybe<DecimalOperationFilterInput>;
  perfPlusMoinsValueFinanciereNette?: InputMaybe<DecimalOperationFilterInput>;
  periodiciteVp?: InputMaybe<PeriodiciteVpFilterInput>;
  produit?: InputMaybe<ProduitFilterInput>;
  refIdProduit?: InputMaybe<StringOperationFilterInput>;
  rppDatedebut?: InputMaybe<LocalDateOperationFilterInput>;
  rppMontantUnitaire?: InputMaybe<DecimalOperationFilterInput>;
  rppPeriodicite?: InputMaybe<StringOperationFilterInput>;
  valorisation?: InputMaybe<DecimalOperationFilterInput>;
  versementInitialBrut?: InputMaybe<DecimalOperationFilterInput>;
  versementInitialNet?: InputMaybe<DecimalOperationFilterInput>;
  vpDateDebut?: InputMaybe<LocalDateOperationFilterInput>;
  vpDuree?: InputMaybe<IntOperationFilterInput>;
  vpMontantUnitaire?: InputMaybe<DecimalOperationFilterInput>;
  vpPeriodicite?: InputMaybe<StringOperationFilterInput>;
};

export type ContratSortInput = {
  clauseBeneficiaire?: InputMaybe<SortEnumType>;
  codeEtatContrat?: InputMaybe<SortEnumType>;
  codeModeGestion?: InputMaybe<SortEnumType>;
  cumulRachats?: InputMaybe<SortEnumType>;
  cumulVersementsBruts?: InputMaybe<SortEnumType>;
  cumulVersementsLibresBruts?: InputMaybe<SortEnumType>;
  cumulVersementsLibresNets?: InputMaybe<SortEnumType>;
  cumulVersementsNets?: InputMaybe<SortEnumType>;
  cumulVpBruts?: InputMaybe<SortEnumType>;
  cumulVpNets?: InputMaybe<SortEnumType>;
  dateDebutContrat?: InputMaybe<SortEnumType>;
  dateDernierVp?: InputMaybe<SortEnumType>;
  dateFinContrat?: InputMaybe<SortEnumType>;
  dateValorisation?: InputMaybe<SortEnumType>;
  epargneSecurisee?: InputMaybe<SortEnumType>;
  flagEpargneHandicap?: InputMaybe<SortEnumType>;
  flagNantissement?: InputMaybe<SortEnumType>;
  flagRpp?: InputMaybe<SortEnumType>;
  flagVp?: InputMaybe<SortEnumType>;
  idContrat?: InputMaybe<SortEnumType>;
  idPartenaire?: InputMaybe<SortEnumType>;
  modeGestion?: InputMaybe<ModeGestionSortInput>;
  numeroContrat?: InputMaybe<SortEnumType>;
  perfPlusMoinsValueFinanciereBrute?: InputMaybe<SortEnumType>;
  perfPlusMoinsValueFinanciereNette?: InputMaybe<SortEnumType>;
  periodiciteVp?: InputMaybe<PeriodiciteVpSortInput>;
  produit?: InputMaybe<ProduitSortInput>;
  refIdProduit?: InputMaybe<SortEnumType>;
  rppDatedebut?: InputMaybe<SortEnumType>;
  rppMontantUnitaire?: InputMaybe<SortEnumType>;
  rppPeriodicite?: InputMaybe<SortEnumType>;
  valorisation?: InputMaybe<SortEnumType>;
  versementInitialBrut?: InputMaybe<SortEnumType>;
  versementInitialNet?: InputMaybe<SortEnumType>;
  vpDateDebut?: InputMaybe<SortEnumType>;
  vpDuree?: InputMaybe<SortEnumType>;
  vpMontantUnitaire?: InputMaybe<SortEnumType>;
  vpPeriodicite?: InputMaybe<SortEnumType>;
};

export type ContratsInvestisseur = {
  __typename?: 'ContratsInvestisseur';
  codeConsultant?: Maybe<Scalars['String']['output']>;
  codeInvestisseur?: Maybe<Scalars['String']['output']>;
  contrat?: Maybe<Contrat>;
  dateChargement?: Maybe<Scalars['LocalDate']['output']>;
  idContrat: Scalars['String']['output'];
  idPartenaire: Scalars['String']['output'];
  idPersonnePartenaire?: Maybe<Scalars['String']['output']>;
  ordreInvestisseur: Scalars['Int']['output'];
};

export type ContratsInvestisseurFilterInput = {
  and?: InputMaybe<Array<ContratsInvestisseurFilterInput>>;
  codeConsultant?: InputMaybe<StringOperationFilterInput>;
  codeInvestisseur?: InputMaybe<StringOperationFilterInput>;
  contrat?: InputMaybe<ContratFilterInput>;
  dateChargement?: InputMaybe<LocalDateOperationFilterInput>;
  idContrat?: InputMaybe<StringOperationFilterInput>;
  idPartenaire?: InputMaybe<StringOperationFilterInput>;
  idPersonnePartenaire?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ContratsInvestisseurFilterInput>>;
  ordreInvestisseur?: InputMaybe<IntOperationFilterInput>;
};

export type ContratsInvestisseurSortInput = {
  codeConsultant?: InputMaybe<SortEnumType>;
  codeInvestisseur?: InputMaybe<SortEnumType>;
  contrat?: InputMaybe<ContratSortInput>;
  dateChargement?: InputMaybe<SortEnumType>;
  idContrat?: InputMaybe<SortEnumType>;
  idPartenaire?: InputMaybe<SortEnumType>;
  idPersonnePartenaire?: InputMaybe<SortEnumType>;
  ordreInvestisseur?: InputMaybe<SortEnumType>;
};

export type ContratsSupport = {
  __typename?: 'ContratsSupport';
  contrat?: Maybe<Contrat>;
  dateChargement?: Maybe<Scalars['LocalDate']['output']>;
  dateCotation?: Maybe<Scalars['LocalDate']['output']>;
  dateValorisation?: Maybe<Scalars['LocalDate']['output']>;
  idPartenaire: Scalars['String']['output'];
  idSupportComposant: Scalars['String']['output'];
  indicateurPma?: Maybe<Scalars['Decimal']['output']>;
  nombreParts?: Maybe<Scalars['Decimal']['output']>;
  perfPlusMoinsValueFinanciere?: Maybe<Scalars['Decimal']['output']>;
  poidsSupportDansContrat?: Maybe<Scalars['Decimal']['output']>;
  refIdContrat?: Maybe<Scalars['String']['output']>;
  refIdSupportInfoGen?: Maybe<Scalars['String']['output']>;
  supportGen?: Maybe<SupportsGen>;
  valeurLiquidative?: Maybe<Scalars['Decimal']['output']>;
  valorisation?: Maybe<Scalars['Decimal']['output']>;
};

export type ContratsSupportFilterInput = {
  and?: InputMaybe<Array<ContratsSupportFilterInput>>;
  contrat?: InputMaybe<ContratFilterInput>;
  dateChargement?: InputMaybe<LocalDateOperationFilterInput>;
  dateCotation?: InputMaybe<LocalDateOperationFilterInput>;
  dateValorisation?: InputMaybe<LocalDateOperationFilterInput>;
  idPartenaire?: InputMaybe<StringOperationFilterInput>;
  idSupportComposant?: InputMaybe<StringOperationFilterInput>;
  indicateurPma?: InputMaybe<DecimalOperationFilterInput>;
  nombreParts?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<ContratsSupportFilterInput>>;
  perfPlusMoinsValueFinanciere?: InputMaybe<DecimalOperationFilterInput>;
  poidsSupportDansContrat?: InputMaybe<DecimalOperationFilterInput>;
  refIdContrat?: InputMaybe<StringOperationFilterInput>;
  refIdSupportInfoGen?: InputMaybe<StringOperationFilterInput>;
  supportGen?: InputMaybe<SupportsGenFilterInput>;
  valeurLiquidative?: InputMaybe<DecimalOperationFilterInput>;
  valorisation?: InputMaybe<DecimalOperationFilterInput>;
};

export type CreateBulkDocumentRequestsInput = {
  derInvestisseurIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  documentRequests: Array<DocumentRequestInput>;
  investisseurIds: Array<Scalars['Long']['input']>;
};

export type CreateDocumentRequestOutput = {
  __typename?: 'CreateDocumentRequestOutput';
  basePath?: Maybe<Scalars['String']['output']>;
  derUploadUrl?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type CreateDocumentRequestsInput = {
  documentRequests: Array<DocumentRequestInput>;
  investisseurId: Scalars['Long']['input'];
  notifyInvestor: Scalars['Boolean']['input'];
  requireDerValidation?: Scalars['Boolean']['input'];
};

export type CreateRecommendationInput = {
  ageRange?: InputMaybe<RecommendationAgeRange>;
  civility: RecommendationCivility;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  relationship?: InputMaybe<RecommendationRelationship>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

export enum DerStatus {
  NotRequested = 'NOT_REQUESTED',
  NotRequired = 'NOT_REQUIRED',
  Pending = 'PENDING',
  Validated = 'VALIDATED'
}

export enum DocumentAction {
  Delete = 'DELETE',
  Replace = 'REPLACE',
  UpdateMetadata = 'UPDATE_METADATA',
  Upload = 'UPLOAD'
}

export enum DocumentEmailTemplateType {
  DocumentRejectedEmail = 'DOCUMENT_REJECTED_EMAIL',
  DocumentRequestEmail = 'DOCUMENT_REQUEST_EMAIL'
}

export type DocumentRequest = {
  __typename?: 'DocumentRequest';
  createdAt: Scalars['DateTime']['output'];
  documentCategoryName?: Maybe<Scalars['String']['output']>;
  documentRequestTypes: Array<DocumentRequestType>;
  documentTypeName?: Maybe<Scalars['String']['output']>;
  documentUploads: Array<DocumentUpload>;
  followUpAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  investisseur?: Maybe<Investisseur>;
  investisseurId: Scalars['Long']['output'];
  isFreeUpload: Scalars['Boolean']['output'];
  rejectedFileName?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  status: DocumentStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DocumentRequestCountsOutput = {
  __typename?: 'DocumentRequestCountsOutput';
  toReview: Scalars['Int']['output'];
  waiting: Scalars['Int']['output'];
};

export type DocumentRequestFilterInput = {
  and?: InputMaybe<Array<DocumentRequestFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  documentCategoryName?: InputMaybe<StringOperationFilterInput>;
  documentRequestTypes?: InputMaybe<ListFilterInputTypeOfDocumentRequestTypeFilterInput>;
  documentTypeName?: InputMaybe<StringOperationFilterInput>;
  documentUploads?: InputMaybe<ListFilterInputTypeOfDocumentUploadFilterInput>;
  followUpAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  isFreeUpload?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<DocumentRequestFilterInput>>;
  rejectedFileName?: InputMaybe<StringOperationFilterInput>;
  rejectionReason?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<DocumentStatusOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type DocumentRequestFilteringValuesOutput = {
  __typename?: 'DocumentRequestFilteringValuesOutput';
  documentStatuses: Array<DocumentStatus>;
  documentTypeCodes: Array<Scalars['String']['output']>;
};

export type DocumentRequestInput = {
  documentCategoryName: Scalars['String']['input'];
  documentRequestTypes: Array<DocumentRequestTypeInput>;
  documentTypeName: Scalars['String']['input'];
};

export type DocumentRequestOutput = {
  __typename?: 'DocumentRequestOutput';
  createdAt: Scalars['DateTime']['output'];
  documentCategoryName?: Maybe<Scalars['String']['output']>;
  documentTypeName?: Maybe<Scalars['String']['output']>;
  documentUploads: Array<DocumentUploadOutput>;
  followUpAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isFreeUpload: Scalars['Boolean']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  requestedTypeCodes: Array<Scalars['String']['output']>;
  status: DocumentStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DocumentRequestSearchInput = {
  documentStatuses: Array<DocumentStatus>;
  documentTypeCodes: Array<Scalars['String']['input']>;
  investisseurId?: InputMaybe<Scalars['Long']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type DocumentRequestSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  documentCategoryName?: InputMaybe<SortEnumType>;
  documentTypeName?: InputMaybe<SortEnumType>;
  followUpAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<InvestisseurSortInput>;
  investisseurId?: InputMaybe<SortEnumType>;
  isFreeUpload?: InputMaybe<SortEnumType>;
  rejectedFileName?: InputMaybe<SortEnumType>;
  rejectionReason?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type DocumentRequestType = {
  __typename?: 'DocumentRequestType';
  documentRequest?: Maybe<DocumentRequest>;
  documentRequestId: Scalars['Int']['output'];
  documentTypeCode?: Maybe<Scalars['String']['output']>;
  documentTypeName?: Maybe<Scalars['String']['output']>;
  expectedDocumentCount: Scalars['Int']['output'];
  hasRectoVerso: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
};

export type DocumentRequestTypeFilterInput = {
  and?: InputMaybe<Array<DocumentRequestTypeFilterInput>>;
  documentRequest?: InputMaybe<DocumentRequestFilterInput>;
  documentRequestId?: InputMaybe<IntOperationFilterInput>;
  documentTypeCode?: InputMaybe<StringOperationFilterInput>;
  documentTypeName?: InputMaybe<StringOperationFilterInput>;
  expectedDocumentCount?: InputMaybe<IntOperationFilterInput>;
  hasRectoVerso?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<DocumentRequestTypeFilterInput>>;
};

export type DocumentRequestTypeInput = {
  documentTypeCode: Scalars['String']['input'];
  documentTypeName: Scalars['String']['input'];
  expectedDocumentCount: Scalars['Int']['input'];
  hasRectoVerso: Scalars['Boolean']['input'];
};

export type DocumentRequestValidationInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  documentRequestId: Scalars['Int']['input'];
  status: DocumentStatus;
};

export type DocumentRequestsByInvestisseurOutput = {
  __typename?: 'DocumentRequestsByInvestisseurOutput';
  documentRequests: Array<DocumentRequestOutput>;
  investisseurCode?: Maybe<Scalars['String']['output']>;
  investisseurId: Scalars['Long']['output'];
  investisseurNom?: Maybe<Scalars['String']['output']>;
  investisseurPrenom?: Maybe<Scalars['String']['output']>;
  latestCreatedAt: Scalars['DateTime']['output'];
  magicLinkUrl?: Maybe<Scalars['String']['output']>;
};

export enum DocumentStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  ToReview = 'TO_REVIEW',
  Uploaded = 'UPLOADED',
  Waiting = 'WAITING'
}

export type DocumentStatusOperationFilterInput = {
  eq?: InputMaybe<DocumentStatus>;
  in?: InputMaybe<Array<DocumentStatus>>;
  neq?: InputMaybe<DocumentStatus>;
  nin?: InputMaybe<Array<DocumentStatus>>;
};

export type DocumentUpload = {
  __typename?: 'DocumentUpload';
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  documentId: Scalars['String']['output'];
  documentRequest?: Maybe<DocumentRequest>;
  documentRequestId: Scalars['Int']['output'];
  documentTypeCode?: Maybe<Scalars['String']['output']>;
  fileExtension: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  side: DocumentUploadSide;
};

export type DocumentUploadFilterInput = {
  and?: InputMaybe<Array<DocumentUploadFilterInput>>;
  contentType?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  documentId?: InputMaybe<StringOperationFilterInput>;
  documentRequest?: InputMaybe<DocumentRequestFilterInput>;
  documentRequestId?: InputMaybe<IntOperationFilterInput>;
  documentTypeCode?: InputMaybe<StringOperationFilterInput>;
  fileExtension?: InputMaybe<StringOperationFilterInput>;
  fileName?: InputMaybe<StringOperationFilterInput>;
  fileSize?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<DocumentUploadFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  side?: InputMaybe<DocumentUploadSideOperationFilterInput>;
};

export type DocumentUploadInput = {
  action?: InputMaybe<DocumentAction>;
  clientReference?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  documentRequestId?: InputMaybe<Scalars['Int']['input']>;
  documentTypeCode?: InputMaybe<Scalars['String']['input']>;
  documentUploadId?: InputMaybe<Scalars['Int']['input']>;
  fileExtension: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  side?: InputMaybe<DocumentUploadSide>;
};

export type DocumentUploadOutput = {
  __typename?: 'DocumentUploadOutput';
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  documentId: Scalars['String']['output'];
  documentTypeCode?: Maybe<Scalars['String']['output']>;
  downloadUrl: Scalars['String']['output'];
  fileExtension: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  side: DocumentUploadSide;
};

export enum DocumentUploadSide {
  Document = 'DOCUMENT',
  Recto = 'RECTO',
  RectoVerso = 'RECTO_VERSO',
  Verso = 'VERSO'
}

export type DocumentUploadSideOperationFilterInput = {
  eq?: InputMaybe<DocumentUploadSide>;
  in?: InputMaybe<Array<DocumentUploadSide>>;
  neq?: InputMaybe<DocumentUploadSide>;
  nin?: InputMaybe<Array<DocumentUploadSide>>;
};

export type Email = {
  __typename?: 'Email';
  adresse: Scalars['String']['output'];
  arianeId?: Maybe<Scalars['Long']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate: Scalars['DateTime']['output'];
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  estAdresseCorrespondance?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  noteId?: Maybe<Scalars['Long']['output']>;
  personnePhysiqueEmails: Array<PersonnePhysiqueEmail>;
  typeEmailCode: Scalars['String']['output'];
};

export type EmailFilterInput = {
  adresse?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<EmailFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  estAdresseCorrespondance?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  noteId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<EmailFilterInput>>;
  personnePhysiqueEmails?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueEmailFilterInput>;
  typeEmailCode?: InputMaybe<StringOperationFilterInput>;
};

export type EmailTemplatePreviewOutput = {
  __typename?: 'EmailTemplatePreviewOutput';
  html?: Maybe<Scalars['String']['output']>;
};

export type Enveloppe = {
  __typename?: 'Enveloppe';
  code: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  libelle?: Maybe<Scalars['String']['output']>;
  produits?: Maybe<Array<Produit>>;
};

export type EnveloppeFilterInput = {
  and?: InputMaybe<Array<EnveloppeFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EnveloppeFilterInput>>;
  produits?: InputMaybe<ListFilterInputTypeOfProduitFilterInput>;
};

export type EnveloppeSortInput = {
  code?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type EtatCivil = {
  __typename?: 'EtatCivil';
  codePaysResidenceStableCouple?: Maybe<Scalars['String']['output']>;
  codePaysResidenceStableCoupleNavigation?: Maybe<Pays>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateChangementSituation?: Maybe<Scalars['LocalDate']['output']>;
  dateContratUnion?: Maybe<Scalars['LocalDate']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  foyerFiscalIdentique: Scalars['Boolean']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  lieuContratUnion?: Maybe<Scalars['String']['output']>;
  nombreEnfantACharge?: Maybe<Scalars['UnsignedByte']['output']>;
  noteId?: Maybe<Scalars['Long']['output']>;
  personnePhysique: PersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
  regimePacsIndivision?: Maybe<Scalars['Boolean']['output']>;
  typeAvantageMatrimonialCode?: Maybe<Scalars['String']['output']>;
  typeRegimeSituationEtatCivilCode?: Maybe<Scalars['String']['output']>;
  typeSituationEtatCivilCode?: Maybe<Scalars['String']['output']>;
  typeSituationEtatCivilCodeNavigation?: Maybe<TypeSituationEtatCivil>;
};

export type EtatCivilFilterInput = {
  and?: InputMaybe<Array<EtatCivilFilterInput>>;
  codePaysResidenceStableCouple?: InputMaybe<StringOperationFilterInput>;
  codePaysResidenceStableCoupleNavigation?: InputMaybe<PaysFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateChangementSituation?: InputMaybe<LocalDateOperationFilterInput>;
  dateContratUnion?: InputMaybe<LocalDateOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  foyerFiscalIdentique?: InputMaybe<BooleanOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  lieuContratUnion?: InputMaybe<StringOperationFilterInput>;
  nombreEnfantACharge?: InputMaybe<UnsignedByteOperationFilterInput>;
  noteId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<EtatCivilFilterInput>>;
  personnePhysique?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
  regimePacsIndivision?: InputMaybe<BooleanOperationFilterInput>;
  typeAvantageMatrimonialCode?: InputMaybe<StringOperationFilterInput>;
  typeRegimeSituationEtatCivilCode?: InputMaybe<StringOperationFilterInput>;
  typeSituationEtatCivilCode?: InputMaybe<StringOperationFilterInput>;
  typeSituationEtatCivilCodeNavigation?: InputMaybe<TypeSituationEtatCivilFilterInput>;
};

export type ExternalDocumentRequestOutput = {
  __typename?: 'ExternalDocumentRequestOutput';
  accountStatus?: Maybe<AccountStatus>;
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  connectionHistory: Array<Scalars['DateTime']['output']>;
  derStatus: DerStatus;
  derValidatedAt?: Maybe<Scalars['DateTime']['output']>;
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  documentRequests: Array<DocumentRequestOutput>;
  investisseurId: Scalars['Long']['output'];
  invitedAt?: Maybe<Scalars['DateTime']['output']>;
  isMagicLinkExpired: Scalars['Boolean']['output'];
  magicLink?: Maybe<Scalars['String']['output']>;
  magicLinkExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  nextAppointmentAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type Investisseur = {
  __typename?: 'Investisseur';
  accountStatus: AccountStatus;
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  connections: Array<InvestisseurConnection>;
  der?: Maybe<ConsultantDer>;
  derId?: Maybe<Scalars['Int']['output']>;
  derValidatedAt?: Maybe<Scalars['DateTime']['output']>;
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  documentRequests: Array<DocumentRequest>;
  entraObjectId?: Maybe<Scalars['UUID']['output']>;
  investisseurCode: Scalars['String']['output'];
  investisseurId: Scalars['Long']['output'];
  invitedAt?: Maybe<Scalars['DateTime']['output']>;
  magicLink?: Maybe<MagicLink>;
  nextAppointmentAt?: Maybe<Scalars['DateTime']['output']>;
  recommendations: Array<Recommendation>;
};

export type InvestisseurConnection = {
  __typename?: 'InvestisseurConnection';
  connectedAt: Scalars['DateTime']['output'];
  id: Scalars['Long']['output'];
  investisseur?: Maybe<Investisseur>;
  investisseurId: Scalars['Long']['output'];
  sessionId: Scalars['String']['output'];
};

export type InvestisseurConnectionFilterInput = {
  and?: InputMaybe<Array<InvestisseurConnectionFilterInput>>;
  connectedAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<InvestisseurConnectionFilterInput>>;
  sessionId?: InputMaybe<StringOperationFilterInput>;
};

export type InvestisseurConsultant = {
  __typename?: 'InvestisseurConsultant';
  actif: Scalars['Int']['output'];
  arianeId?: Maybe<Scalars['Long']['output']>;
  batchDateUpdate?: Maybe<Scalars['DateTime']['output']>;
  causeDesactivation?: Maybe<Scalars['UnsignedByte']['output']>;
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateActivation: Scalars['DateTime']['output'];
  dateDesactivation?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  investisseur: AtlasInvestisseur;
  investisseurId: Scalars['Long']['output'];
  typeRelationInvestisseurConsultantCode: Scalars['String']['output'];
};

export type InvestisseurConsultantFilterInput = {
  actif?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<InvestisseurConsultantFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  batchDateUpdate?: InputMaybe<DateTimeOperationFilterInput>;
  causeDesactivation?: InputMaybe<UnsignedByteOperationFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateActivation?: InputMaybe<DateTimeOperationFilterInput>;
  dateDesactivation?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<AtlasInvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<InvestisseurConsultantFilterInput>>;
  typeRelationInvestisseurConsultantCode?: InputMaybe<StringOperationFilterInput>;
};

export type InvestisseurErrorOutput = {
  __typename?: 'InvestisseurErrorOutput';
  investisseurId: Scalars['Long']['output'];
  message: Scalars['String']['output'];
};

export type InvestisseurFilterInput = {
  accountStatus?: InputMaybe<AccountStatusOperationFilterInput>;
  activatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<InvestisseurFilterInput>>;
  connections?: InputMaybe<ListFilterInputTypeOfInvestisseurConnectionFilterInput>;
  der?: InputMaybe<ConsultantDerFilterInput>;
  derId?: InputMaybe<IntOperationFilterInput>;
  derValidatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  disabledAt?: InputMaybe<DateTimeOperationFilterInput>;
  documentRequests?: InputMaybe<ListFilterInputTypeOfDocumentRequestFilterInput>;
  entraObjectId?: InputMaybe<UuidOperationFilterInput>;
  investisseurCode?: InputMaybe<StringOperationFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  invitedAt?: InputMaybe<DateTimeOperationFilterInput>;
  magicLink?: InputMaybe<MagicLinkFilterInput>;
  nextAppointmentAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<InvestisseurFilterInput>>;
  recommendations?: InputMaybe<ListFilterInputTypeOfRecommendationFilterInput>;
};

export type InvestisseurPersonnePhysique = {
  __typename?: 'InvestisseurPersonnePhysique';
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  investisseur: AtlasInvestisseur;
  investisseurId: Scalars['Long']['output'];
  personnePhysique: PersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
};

export type InvestisseurPersonnePhysiqueFilterInput = {
  and?: InputMaybe<Array<InvestisseurPersonnePhysiqueFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  investisseur?: InputMaybe<AtlasInvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<InvestisseurPersonnePhysiqueFilterInput>>;
  personnePhysique?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
};

export type InvestisseurSortInput = {
  accountStatus?: InputMaybe<SortEnumType>;
  activatedAt?: InputMaybe<SortEnumType>;
  der?: InputMaybe<ConsultantDerSortInput>;
  derId?: InputMaybe<SortEnumType>;
  derValidatedAt?: InputMaybe<SortEnumType>;
  disabledAt?: InputMaybe<SortEnumType>;
  entraObjectId?: InputMaybe<SortEnumType>;
  investisseurCode?: InputMaybe<SortEnumType>;
  investisseurId?: InputMaybe<SortEnumType>;
  invitedAt?: InputMaybe<SortEnumType>;
  magicLink?: InputMaybe<MagicLinkSortInput>;
  nextAppointmentAt?: InputMaybe<SortEnumType>;
};

export type ListFilterInputTypeOfAdresseFilterInput = {
  all?: InputMaybe<AdresseFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AdresseFilterInput>;
  some?: InputMaybe<AdresseFilterInput>;
};

export type ListFilterInputTypeOfAtlasInvestisseurFilterInput = {
  all?: InputMaybe<AtlasInvestisseurFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AtlasInvestisseurFilterInput>;
  some?: InputMaybe<AtlasInvestisseurFilterInput>;
};

export type ListFilterInputTypeOfConsultantFilterInput = {
  all?: InputMaybe<ConsultantFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantFilterInput>;
  some?: InputMaybe<ConsultantFilterInput>;
};

export type ListFilterInputTypeOfConsultantHabilitationFilterInput = {
  all?: InputMaybe<ConsultantHabilitationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantHabilitationFilterInput>;
  some?: InputMaybe<ConsultantHabilitationFilterInput>;
};

export type ListFilterInputTypeOfConsultantHabilitationInscriptionFilterInput = {
  all?: InputMaybe<ConsultantHabilitationInscriptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantHabilitationInscriptionFilterInput>;
  some?: InputMaybe<ConsultantHabilitationInscriptionFilterInput>;
};

export type ListFilterInputTypeOfConsultantPersonnePhysiqueFilterInput = {
  all?: InputMaybe<ConsultantPersonnePhysiqueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantPersonnePhysiqueFilterInput>;
  some?: InputMaybe<ConsultantPersonnePhysiqueFilterInput>;
};

export type ListFilterInputTypeOfConsultantStatutJuridiqueFilterInput = {
  all?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
  some?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
};

export type ListFilterInputTypeOfContratsInvestisseurFilterInput = {
  all?: InputMaybe<ContratsInvestisseurFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ContratsInvestisseurFilterInput>;
  some?: InputMaybe<ContratsInvestisseurFilterInput>;
};

export type ListFilterInputTypeOfContratsSupportFilterInput = {
  all?: InputMaybe<ContratsSupportFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ContratsSupportFilterInput>;
  some?: InputMaybe<ContratsSupportFilterInput>;
};

export type ListFilterInputTypeOfDocumentRequestFilterInput = {
  all?: InputMaybe<DocumentRequestFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DocumentRequestFilterInput>;
  some?: InputMaybe<DocumentRequestFilterInput>;
};

export type ListFilterInputTypeOfDocumentRequestTypeFilterInput = {
  all?: InputMaybe<DocumentRequestTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DocumentRequestTypeFilterInput>;
  some?: InputMaybe<DocumentRequestTypeFilterInput>;
};

export type ListFilterInputTypeOfDocumentUploadFilterInput = {
  all?: InputMaybe<DocumentUploadFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DocumentUploadFilterInput>;
  some?: InputMaybe<DocumentUploadFilterInput>;
};

export type ListFilterInputTypeOfEtatCivilFilterInput = {
  all?: InputMaybe<EtatCivilFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EtatCivilFilterInput>;
  some?: InputMaybe<EtatCivilFilterInput>;
};

export type ListFilterInputTypeOfInvestisseurConnectionFilterInput = {
  all?: InputMaybe<InvestisseurConnectionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InvestisseurConnectionFilterInput>;
  some?: InputMaybe<InvestisseurConnectionFilterInput>;
};

export type ListFilterInputTypeOfInvestisseurConsultantFilterInput = {
  all?: InputMaybe<InvestisseurConsultantFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InvestisseurConsultantFilterInput>;
  some?: InputMaybe<InvestisseurConsultantFilterInput>;
};

export type ListFilterInputTypeOfInvestisseurFilterInput = {
  all?: InputMaybe<InvestisseurFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InvestisseurFilterInput>;
  some?: InputMaybe<InvestisseurFilterInput>;
};

export type ListFilterInputTypeOfInvestisseurPersonnePhysiqueFilterInput = {
  all?: InputMaybe<InvestisseurPersonnePhysiqueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InvestisseurPersonnePhysiqueFilterInput>;
  some?: InputMaybe<InvestisseurPersonnePhysiqueFilterInput>;
};

export type ListFilterInputTypeOfPaysFilterInput = {
  all?: InputMaybe<PaysFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PaysFilterInput>;
  some?: InputMaybe<PaysFilterInput>;
};

export type ListFilterInputTypeOfPersonnePhysiqueAdresseFilterInput = {
  all?: InputMaybe<PersonnePhysiqueAdresseFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PersonnePhysiqueAdresseFilterInput>;
  some?: InputMaybe<PersonnePhysiqueAdresseFilterInput>;
};

export type ListFilterInputTypeOfPersonnePhysiqueEmailFilterInput = {
  all?: InputMaybe<PersonnePhysiqueEmailFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PersonnePhysiqueEmailFilterInput>;
  some?: InputMaybe<PersonnePhysiqueEmailFilterInput>;
};

export type ListFilterInputTypeOfPersonnePhysiqueFilterInput = {
  all?: InputMaybe<PersonnePhysiqueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PersonnePhysiqueFilterInput>;
  some?: InputMaybe<PersonnePhysiqueFilterInput>;
};

export type ListFilterInputTypeOfPersonnePhysiqueTelephoneFilterInput = {
  all?: InputMaybe<PersonnePhysiqueTelephoneFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PersonnePhysiqueTelephoneFilterInput>;
  some?: InputMaybe<PersonnePhysiqueTelephoneFilterInput>;
};

export type ListFilterInputTypeOfProduitFilterInput = {
  all?: InputMaybe<ProduitFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProduitFilterInput>;
  some?: InputMaybe<ProduitFilterInput>;
};

export type ListFilterInputTypeOfRecommendationFilterInput = {
  all?: InputMaybe<RecommendationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RecommendationFilterInput>;
  some?: InputMaybe<RecommendationFilterInput>;
};

export type LocalDateOperationFilterInput = {
  eq?: InputMaybe<Scalars['LocalDate']['input']>;
  gt?: InputMaybe<Scalars['LocalDate']['input']>;
  gte?: InputMaybe<Scalars['LocalDate']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  lt?: InputMaybe<Scalars['LocalDate']['input']>;
  lte?: InputMaybe<Scalars['LocalDate']['input']>;
  neq?: InputMaybe<Scalars['LocalDate']['input']>;
  ngt?: InputMaybe<Scalars['LocalDate']['input']>;
  ngte?: InputMaybe<Scalars['LocalDate']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  nlt?: InputMaybe<Scalars['LocalDate']['input']>;
  nlte?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type LongOperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  neq?: InputMaybe<Scalars['Long']['input']>;
  ngt?: InputMaybe<Scalars['Long']['input']>;
  ngte?: InputMaybe<Scalars['Long']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  nlt?: InputMaybe<Scalars['Long']['input']>;
  nlte?: InputMaybe<Scalars['Long']['input']>;
};

export type MagicLink = {
  __typename?: 'MagicLink';
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  investisseur?: Maybe<Investisseur>;
  investisseurId: Scalars['Long']['output'];
  key: Scalars['String']['output'];
};

export type MagicLinkFilterInput = {
  and?: InputMaybe<Array<MagicLinkFilterInput>>;
  expiresAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MagicLinkFilterInput>>;
};

export type MagicLinkSortInput = {
  expiresAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<InvestisseurSortInput>;
  investisseurId?: InputMaybe<SortEnumType>;
  key?: InputMaybe<SortEnumType>;
};

export type MagicLoginInput = {
  key: Scalars['String']['input'];
};

export type MagicLoginOutput = {
  __typename?: 'MagicLoginOutput';
  accessToken?: Maybe<Scalars['String']['output']>;
};

export type ModeGestion = {
  __typename?: 'ModeGestion';
  code?: Maybe<Scalars['String']['output']>;
  libelle?: Maybe<Scalars['String']['output']>;
};

export type ModeGestionFilterInput = {
  and?: InputMaybe<Array<ModeGestionFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ModeGestionFilterInput>>;
};

export type ModeGestionSortInput = {
  code?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Creates the same document requests for several investisseurs at once and notifies all of them by email */
  createBulkDocumentRequests: BulkCreateDocumentRequestsOutput;
  /** Creates document requests for one or more uploads */
  createDocumentRequests: CreateDocumentRequestOutput;
  /** Creates a recommendation and send emails */
  createRecommendation: Scalars['Boolean']['output'];
  /** Deletes a document request, its linked uploads, and the associated blobs. */
  deleteDocumentRequest: Scalars['Boolean']['output'];
  /** Disables the authenticated investisseur's own Entra account */
  disableInvestisseurAccount: Scalars['Boolean']['output'];
  /** Log in a user with a magic link key. */
  loginWithMagic: MagicLoginOutput;
  /** Records an application login for the authenticated investisseur, once per session identifier. */
  recordEntraConnection: RecordEntraConnectionOutput;
  /** Refreshes a user's JWT token using a magic link key. */
  refreshMagicJwt: MagicLoginOutput;
  /** Regenerates an investisseur's magic link (after it expired and was deleted) for their still-pending document requests. */
  regenerateMagicLink: CreateDocumentRequestOutput;
  /** Creates/invites an Entra account for an investisseur and sends an activation email. */
  requestInvestisseurAccountActivation: Scalars['Boolean']['output'];
  /** Send Follow-up mail to investisseur */
  sendFollowUpMail: Scalars['Boolean']['output'];
  /** Sets or updates the investisseur's next appointment with their consultant, removes it when no date is given. */
  setInvestisseurNextAppointment: Scalars['Boolean']['output'];
  /** Transmits document requests to a consultant. */
  transmitDocumentsToConsultant: TransmitDocumentOutput;
  /** Creates document requests for one or more uploads and returns one SAS URL per document. */
  uploadFreeDocuments: Array<UploadUrlOutput>;
  /** Upload/delete/replace/update documents from an existing document request and returns one SAS URL per document. */
  uploadRequestDocuments: Array<UploadUrlOutput>;
  /** Validates the DER pending for the authenticated investisseur. */
  validateDer: Scalars['Boolean']['output'];
  /** Validate document requests for one or more uploads */
  validateDocumentRequests: ValidateDocumentRequestOutput;
};


export type MutationCreateBulkDocumentRequestsArgs = {
  input: CreateBulkDocumentRequestsInput;
};


export type MutationCreateDocumentRequestsArgs = {
  input: CreateDocumentRequestsInput;
};


export type MutationCreateRecommendationArgs = {
  input: CreateRecommendationInput;
};


export type MutationDeleteDocumentRequestArgs = {
  documentRequestId: Scalars['Int']['input'];
};


export type MutationLoginWithMagicArgs = {
  input: MagicLoginInput;
};


export type MutationRecordEntraConnectionArgs = {
  sessionId: Scalars['UUID']['input'];
};


export type MutationRegenerateMagicLinkArgs = {
  input: RegenerateMagicLinkInput;
};


export type MutationRequestInvestisseurAccountActivationArgs = {
  investisseurId: Scalars['Long']['input'];
};


export type MutationSendFollowUpMailArgs = {
  investisseurId: Scalars['Long']['input'];
};


export type MutationSetInvestisseurNextAppointmentArgs = {
  input: SetInvestisseurNextAppointmentInput;
};


export type MutationTransmitDocumentsToConsultantArgs = {
  documentRequestIds: Array<Scalars['Int']['input']>;
};


export type MutationUploadFreeDocumentsArgs = {
  inputs: Array<DocumentUploadInput>;
};


export type MutationUploadRequestDocumentsArgs = {
  documentRequestId: Scalars['Int']['input'];
  inputs: Array<DocumentUploadInput>;
};


export type MutationValidateDocumentRequestsArgs = {
  input: ValidateDocumentRequestsInput;
};

export type MyStelliumInvestisseurOutput = {
  __typename?: 'MyStelliumInvestisseurOutput';
  nextAppointmentAt?: Maybe<Scalars['DateTime']['output']>;
};

export type NullableOfRecommendationAgeRangeOperationFilterInput = {
  eq?: InputMaybe<RecommendationAgeRange>;
  in?: InputMaybe<Array<InputMaybe<RecommendationAgeRange>>>;
  neq?: InputMaybe<RecommendationAgeRange>;
  nin?: InputMaybe<Array<InputMaybe<RecommendationAgeRange>>>;
};

export type NullableOfRecommendationRelationshipOperationFilterInput = {
  eq?: InputMaybe<RecommendationRelationship>;
  in?: InputMaybe<Array<InputMaybe<RecommendationRelationship>>>;
  neq?: InputMaybe<RecommendationRelationship>;
  nin?: InputMaybe<Array<InputMaybe<RecommendationRelationship>>>;
};

export type PaginatedResultOfDocumentRequestsByInvestisseurOutput = {
  __typename?: 'PaginatedResultOfDocumentRequestsByInvestisseurOutput';
  items: Array<DocumentRequestsByInvestisseurOutput>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Partenaire = {
  __typename?: 'Partenaire';
  idPartenaire: Scalars['String']['output'];
  libelleCourt?: Maybe<Scalars['String']['output']>;
  libelleLong?: Maybe<Scalars['String']['output']>;
};

export type PartenaireFilterInput = {
  and?: InputMaybe<Array<PartenaireFilterInput>>;
  idPartenaire?: InputMaybe<StringOperationFilterInput>;
  libelleCourt?: InputMaybe<StringOperationFilterInput>;
  libelleLong?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PartenaireFilterInput>>;
};

export type PartenaireSortInput = {
  idPartenaire?: InputMaybe<SortEnumType>;
  libelleCourt?: InputMaybe<SortEnumType>;
  libelleLong?: InputMaybe<SortEnumType>;
};

export type Pays = {
  __typename?: 'Pays';
  actif?: Maybe<Scalars['Boolean']['output']>;
  adresses: Array<Adresse>;
  code: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  etatCivils: Array<EtatCivil>;
  inverseNationaliteCodeNavigation: Array<Pays>;
  libelle: Scalars['String']['output'];
  nationalite?: Maybe<Scalars['String']['output']>;
  nationaliteCode: Scalars['String']['output'];
  nationaliteCodeNavigation: Pays;
  personnePhysiqueCodePaysNaissanceNavigations: Array<PersonnePhysique>;
  personnePhysiqueCodePaysNationaliteNavigations: Array<PersonnePhysique>;
  personnePhysiqueCodePaysNationaliteSecondaireNavigations: Array<PersonnePhysique>;
};

export type PaysFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  adresses?: InputMaybe<ListFilterInputTypeOfAdresseFilterInput>;
  and?: InputMaybe<Array<PaysFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  etatCivils?: InputMaybe<ListFilterInputTypeOfEtatCivilFilterInput>;
  inverseNationaliteCodeNavigation?: InputMaybe<ListFilterInputTypeOfPaysFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  nationalite?: InputMaybe<StringOperationFilterInput>;
  nationaliteCode?: InputMaybe<StringOperationFilterInput>;
  nationaliteCodeNavigation?: InputMaybe<PaysFilterInput>;
  or?: InputMaybe<Array<PaysFilterInput>>;
  personnePhysiqueCodePaysNaissanceNavigations?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
  personnePhysiqueCodePaysNationaliteNavigations?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
  personnePhysiqueCodePaysNationaliteSecondaireNavigations?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
};

export type PendingDerOutput = {
  __typename?: 'PendingDerOutput';
  downloadUrl: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  viewUrl: Scalars['String']['output'];
};

export type PeriodiciteVp = {
  __typename?: 'PeriodiciteVp';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  libelle?: Maybe<Scalars['String']['output']>;
};

export type PeriodiciteVpFilterInput = {
  and?: InputMaybe<Array<PeriodiciteVpFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PeriodiciteVpFilterInput>>;
};

export type PeriodiciteVpSortInput = {
  code?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type PersonnePhysique = {
  __typename?: 'PersonnePhysique';
  arianeId?: Maybe<Scalars['Long']['output']>;
  civiliteCode: Scalars['String']['output'];
  code?: Maybe<Scalars['String']['output']>;
  codePaysNaissance?: Maybe<Scalars['String']['output']>;
  codePaysNaissanceNavigation?: Maybe<Pays>;
  codePaysNationalite?: Maybe<Scalars['String']['output']>;
  codePaysNationaliteNavigation?: Maybe<Pays>;
  codePaysNationaliteSecondaire?: Maybe<Scalars['String']['output']>;
  codePaysNationaliteSecondaireNavigation?: Maybe<Pays>;
  codePostaleNaissance?: Maybe<Scalars['String']['output']>;
  consultantPersonnePhysiques: Array<ConsultantPersonnePhysique>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateNaissance?: Maybe<Scalars['LocalDate']['output']>;
  departementNaissance?: Maybe<Scalars['String']['output']>;
  deuxiemePrenom?: Maybe<Scalars['String']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  etatCivil?: Maybe<EtatCivil>;
  fullNameSearchText: Scalars['String']['output'];
  genre?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  investisseurPersonnePhysiques: Array<InvestisseurPersonnePhysique>;
  login?: Maybe<Scalars['String']['output']>;
  mesureProtectionDate?: Maybe<Scalars['LocalDate']['output']>;
  nom: Scalars['String']['output'];
  nomCompletDeuxiemeParent?: Maybe<Scalars['String']['output']>;
  nomCompletPremierParent?: Maybe<Scalars['String']['output']>;
  nomNaissance?: Maybe<Scalars['String']['output']>;
  nomNaissanceUniformise?: Maybe<Scalars['String']['output']>;
  nomUniformise: Scalars['String']['output'];
  personnePhysiqueAdresses: Array<PersonnePhysiqueAdresse>;
  personnePhysiqueEmails: Array<PersonnePhysiqueEmail>;
  personnePhysiqueTelephones: Array<PersonnePhysiqueTelephone>;
  prenom: Scalars['String']['output'];
  prenomUniformise: Scalars['String']['output'];
  troisiemePrenom?: Maybe<Scalars['String']['output']>;
  typeMesureProtectionCode?: Maybe<Scalars['String']['output']>;
  villeNaissanceNom?: Maybe<Scalars['String']['output']>;
};

export type PersonnePhysiqueAdresse = {
  __typename?: 'PersonnePhysiqueAdresse';
  adresse: Adresse;
  adresseId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  personnePhysique: PersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
};

export type PersonnePhysiqueAdresseFilterInput = {
  adresse?: InputMaybe<AdresseFilterInput>;
  adresseId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<PersonnePhysiqueAdresseFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<PersonnePhysiqueAdresseFilterInput>>;
  personnePhysique?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
};

export type PersonnePhysiqueEmail = {
  __typename?: 'PersonnePhysiqueEmail';
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  email: Email;
  emailId: Scalars['Long']['output'];
  personnePhysique: PersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
};

export type PersonnePhysiqueEmailFilterInput = {
  and?: InputMaybe<Array<PersonnePhysiqueEmailFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<EmailFilterInput>;
  emailId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<PersonnePhysiqueEmailFilterInput>>;
  personnePhysique?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
};

export type PersonnePhysiqueFilterInput = {
  and?: InputMaybe<Array<PersonnePhysiqueFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  civiliteCode?: InputMaybe<StringOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  codePaysNaissance?: InputMaybe<StringOperationFilterInput>;
  codePaysNaissanceNavigation?: InputMaybe<PaysFilterInput>;
  codePaysNationalite?: InputMaybe<StringOperationFilterInput>;
  codePaysNationaliteNavigation?: InputMaybe<PaysFilterInput>;
  codePaysNationaliteSecondaire?: InputMaybe<StringOperationFilterInput>;
  codePaysNationaliteSecondaireNavigation?: InputMaybe<PaysFilterInput>;
  codePostaleNaissance?: InputMaybe<StringOperationFilterInput>;
  consultantPersonnePhysiques?: InputMaybe<ListFilterInputTypeOfConsultantPersonnePhysiqueFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateNaissance?: InputMaybe<LocalDateOperationFilterInput>;
  departementNaissance?: InputMaybe<StringOperationFilterInput>;
  deuxiemePrenom?: InputMaybe<StringOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  etatCivil?: InputMaybe<EtatCivilFilterInput>;
  fullNameSearchText?: InputMaybe<StringOperationFilterInput>;
  genre?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  investisseurPersonnePhysiques?: InputMaybe<ListFilterInputTypeOfInvestisseurPersonnePhysiqueFilterInput>;
  login?: InputMaybe<StringOperationFilterInput>;
  mesureProtectionDate?: InputMaybe<LocalDateOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  nomCompletDeuxiemeParent?: InputMaybe<StringOperationFilterInput>;
  nomCompletPremierParent?: InputMaybe<StringOperationFilterInput>;
  nomNaissance?: InputMaybe<StringOperationFilterInput>;
  nomNaissanceUniformise?: InputMaybe<StringOperationFilterInput>;
  nomUniformise?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PersonnePhysiqueFilterInput>>;
  personnePhysiqueAdresses?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueAdresseFilterInput>;
  personnePhysiqueEmails?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueEmailFilterInput>;
  personnePhysiqueTelephones?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueTelephoneFilterInput>;
  prenom?: InputMaybe<StringOperationFilterInput>;
  prenomUniformise?: InputMaybe<StringOperationFilterInput>;
  troisiemePrenom?: InputMaybe<StringOperationFilterInput>;
  typeMesureProtectionCode?: InputMaybe<StringOperationFilterInput>;
  villeNaissanceNom?: InputMaybe<StringOperationFilterInput>;
};

export type PersonnePhysiqueTelephone = {
  __typename?: 'PersonnePhysiqueTelephone';
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  personnePhysique: PersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
  telephone: Telephone;
  telephoneId: Scalars['Long']['output'];
};

export type PersonnePhysiqueTelephoneFilterInput = {
  and?: InputMaybe<Array<PersonnePhysiqueTelephoneFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<PersonnePhysiqueTelephoneFilterInput>>;
  personnePhysique?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
  telephone?: InputMaybe<TelephoneFilterInput>;
  telephoneId?: InputMaybe<LongOperationFilterInput>;
};

export type PreviewDocumentEmailTemplateDocumentInput = {
  name: Scalars['String']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
};

export type PreviewDocumentEmailTemplateInput = {
  accessWithMagicLink: Scalars['Boolean']['input'];
  documents: Array<PreviewDocumentEmailTemplateDocumentInput>;
  investorName: Scalars['String']['input'];
  templateType: DocumentEmailTemplateType;
};

export type Produit = {
  __typename?: 'Produit';
  designation?: Maybe<Scalars['String']['output']>;
  enveloppe?: Maybe<Enveloppe>;
  idProduit: Scalars['String']['output'];
  partenaire?: Maybe<Partenaire>;
  refCodeEnveloppe?: Maybe<Scalars['String']['output']>;
  refCodeTypeProduit?: Maybe<Scalars['String']['output']>;
  refIdPartenaire?: Maybe<Scalars['String']['output']>;
  typeProduit?: Maybe<TypeProduit>;
};

export type ProduitFilterInput = {
  and?: InputMaybe<Array<ProduitFilterInput>>;
  designation?: InputMaybe<StringOperationFilterInput>;
  enveloppe?: InputMaybe<EnveloppeFilterInput>;
  idProduit?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProduitFilterInput>>;
  partenaire?: InputMaybe<PartenaireFilterInput>;
  refCodeEnveloppe?: InputMaybe<StringOperationFilterInput>;
  refCodeTypeProduit?: InputMaybe<StringOperationFilterInput>;
  refIdPartenaire?: InputMaybe<StringOperationFilterInput>;
  typeProduit?: InputMaybe<TypeProduitFilterInput>;
};

export type ProduitSortInput = {
  designation?: InputMaybe<SortEnumType>;
  enveloppe?: InputMaybe<EnveloppeSortInput>;
  idProduit?: InputMaybe<SortEnumType>;
  partenaire?: InputMaybe<PartenaireSortInput>;
  refCodeEnveloppe?: InputMaybe<SortEnumType>;
  refCodeTypeProduit?: InputMaybe<SortEnumType>;
  refIdPartenaire?: InputMaybe<SortEnumType>;
  typeProduit?: InputMaybe<TypeProduitSortInput>;
};

export type Query = {
  __typename?: 'Query';
  /** Get agregation datas. */
  agregation: Array<ContratsInvestisseur>;
  /** Get atlas datas. */
  atlas?: Maybe<AtlasInvestisseur>;
  /** Get document request counts for a consultant. */
  documentRequestCounts: DocumentRequestCountsOutput;
  /** Get filter values for document requests */
  documentRequestFilteringValues: DocumentRequestFilteringValuesOutput;
  /** Get document requests datas. */
  documentRequests: Array<DocumentRequest>;
  /** Get filtered document requests, paginated and grouped by investisseur. */
  filteredDocumentRequestPaginated: PaginatedResultOfDocumentRequestsByInvestisseurOutput;
  /** Get document requests for an investisseur. */
  investisseurDocumentRequestsForConsultant: ExternalDocumentRequestOutput;
  /** Get the MyStellium data of the authenticated investisseur, null if they do not exist in MyStellium. */
  myStelliumInvestisseur?: Maybe<MyStelliumInvestisseurOutput>;
  /** Get the DER the authenticated investisseur still has to validate, null if there is none. */
  pendingDer?: Maybe<PendingDerOutput>;
  /** Preview a document email template (document request or document rejected). */
  previewDocumentEmailTemplate: EmailTemplatePreviewOutput;
};


export type QueryAgregationArgs = {
  order?: InputMaybe<Array<ContratsInvestisseurSortInput>>;
  where?: InputMaybe<ContratsInvestisseurFilterInput>;
};


export type QueryAtlasArgs = {
  where?: InputMaybe<AtlasInvestisseurFilterInput>;
};


export type QueryDocumentRequestsArgs = {
  order?: InputMaybe<Array<DocumentRequestSortInput>>;
  where?: InputMaybe<DocumentRequestFilterInput>;
};


export type QueryFilteredDocumentRequestPaginatedArgs = {
  searchInput: DocumentRequestSearchInput;
};


export type QueryInvestisseurDocumentRequestsForConsultantArgs = {
  investisseurId: Scalars['Long']['input'];
};


export type QueryPreviewDocumentEmailTemplateArgs = {
  input: PreviewDocumentEmailTemplateInput;
};

export type Recommendation = {
  __typename?: 'Recommendation';
  ageRange?: Maybe<RecommendationAgeRange>;
  civility: RecommendationCivility;
  consultantId: Scalars['Long']['output'];
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  investisseur?: Maybe<Investisseur>;
  investisseurId: Scalars['Long']['output'];
  lastName: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  relationship?: Maybe<RecommendationRelationship>;
};

export enum RecommendationAgeRange {
  From18To29 = 'FROM18_TO29',
  From30To39 = 'FROM30_TO39',
  From40To49 = 'FROM40_TO49',
  From50To64 = 'FROM50_TO64',
  From65AndOver = 'FROM65_AND_OVER'
}

export enum RecommendationCivility {
  Madame = 'MADAME',
  Monsieur = 'MONSIEUR'
}

export type RecommendationCivilityOperationFilterInput = {
  eq?: InputMaybe<RecommendationCivility>;
  in?: InputMaybe<Array<RecommendationCivility>>;
  neq?: InputMaybe<RecommendationCivility>;
  nin?: InputMaybe<Array<RecommendationCivility>>;
};

export type RecommendationFilterInput = {
  ageRange?: InputMaybe<NullableOfRecommendationAgeRangeOperationFilterInput>;
  and?: InputMaybe<Array<RecommendationFilterInput>>;
  civility?: InputMaybe<RecommendationCivilityOperationFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RecommendationFilterInput>>;
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  relationship?: InputMaybe<NullableOfRecommendationRelationshipOperationFilterInput>;
};

export enum RecommendationRelationship {
  Acquaintance = 'ACQUAINTANCE',
  Family = 'FAMILY',
  Friend = 'FRIEND'
}

export type RecordEntraConnectionOutput = {
  __typename?: 'RecordEntraConnectionOutput';
  isFirstConnection: Scalars['Boolean']['output'];
};

export type RegenerateMagicLinkInput = {
  investisseurId: Scalars['Long']['input'];
  notifyInvestor: Scalars['Boolean']['input'];
};

export type SetInvestisseurNextAppointmentInput = {
  investisseurId: Scalars['Long']['input'];
  nextAppointmentAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SupportsClassesActif = {
  __typename?: 'SupportsClassesActif';
  classeActif?: Maybe<Scalars['String']['output']>;
  codeIsin: Scalars['String']['output'];
  libelleSupport?: Maybe<Scalars['String']['output']>;
};

export type SupportsClassesActifFilterInput = {
  and?: InputMaybe<Array<SupportsClassesActifFilterInput>>;
  classeActif?: InputMaybe<StringOperationFilterInput>;
  codeIsin?: InputMaybe<StringOperationFilterInput>;
  libelleSupport?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SupportsClassesActifFilterInput>>;
};

export type SupportsGen = {
  __typename?: 'SupportsGen';
  idSupportInfoGen: Scalars['String']['output'];
  isin?: Maybe<Scalars['String']['output']>;
  supportsClassesActif?: Maybe<SupportsClassesActif>;
};

export type SupportsGenFilterInput = {
  and?: InputMaybe<Array<SupportsGenFilterInput>>;
  idSupportInfoGen?: InputMaybe<StringOperationFilterInput>;
  isin?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SupportsGenFilterInput>>;
  supportsClassesActif?: InputMaybe<SupportsClassesActifFilterInput>;
};

export type Telephone = {
  __typename?: 'Telephone';
  arianeId?: Maybe<Scalars['Long']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate: Scalars['DateTime']['output'];
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  estNumeroCorrespondance?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  noteId?: Maybe<Scalars['Long']['output']>;
  numero: Scalars['String']['output'];
  personnePhysiqueTelephones: Array<PersonnePhysiqueTelephone>;
  prefixe?: Maybe<Scalars['String']['output']>;
  typeTelephoneCode: Scalars['String']['output'];
};

export type TelephoneFilterInput = {
  and?: InputMaybe<Array<TelephoneFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  estNumeroCorrespondance?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  noteId?: InputMaybe<LongOperationFilterInput>;
  numero?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TelephoneFilterInput>>;
  personnePhysiqueTelephones?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueTelephoneFilterInput>;
  prefixe?: InputMaybe<StringOperationFilterInput>;
  typeTelephoneCode?: InputMaybe<StringOperationFilterInput>;
};

export type TransmitDocumentOutput = {
  __typename?: 'TransmitDocumentOutput';
  redirectOutMagicLink: Scalars['Boolean']['output'];
  transmittedDocumentRequestIds: Array<Scalars['Int']['output']>;
};

export type TypeProduit = {
  __typename?: 'TypeProduit';
  code: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  libelle?: Maybe<Scalars['String']['output']>;
  produits?: Maybe<Array<Produit>>;
};

export type TypeProduitFilterInput = {
  and?: InputMaybe<Array<TypeProduitFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeProduitFilterInput>>;
  produits?: InputMaybe<ListFilterInputTypeOfProduitFilterInput>;
};

export type TypeProduitSortInput = {
  code?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypeSituationEtatCivil = {
  __typename?: 'TypeSituationEtatCivil';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  etatCivils: Array<EtatCivil>;
  libelle: Scalars['String']['output'];
};

export type TypeSituationEtatCivilFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeSituationEtatCivilFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  etatCivils?: InputMaybe<ListFilterInputTypeOfEtatCivilFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeSituationEtatCivilFilterInput>>;
};

export type UnsignedByteOperationFilterInput = {
  eq?: InputMaybe<Scalars['UnsignedByte']['input']>;
  gt?: InputMaybe<Scalars['UnsignedByte']['input']>;
  gte?: InputMaybe<Scalars['UnsignedByte']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedByte']['input']>>>;
  lt?: InputMaybe<Scalars['UnsignedByte']['input']>;
  lte?: InputMaybe<Scalars['UnsignedByte']['input']>;
  neq?: InputMaybe<Scalars['UnsignedByte']['input']>;
  ngt?: InputMaybe<Scalars['UnsignedByte']['input']>;
  ngte?: InputMaybe<Scalars['UnsignedByte']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UnsignedByte']['input']>>>;
  nlt?: InputMaybe<Scalars['UnsignedByte']['input']>;
  nlte?: InputMaybe<Scalars['UnsignedByte']['input']>;
};

export type UploadUrlOutput = {
  __typename?: 'UploadUrlOutput';
  clientReference?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

export type ValidateDocumentRequestOutput = {
  __typename?: 'ValidateDocumentRequestOutput';
  basePath?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ValidateDocumentRequestsInput = {
  investisseurId: Scalars['Long']['input'];
  notifyInvestor: Scalars['Boolean']['input'];
  validationInputs: Array<DocumentRequestValidationInput>;
};

export type CreateBulkDocumentRequestsMutationVariables = Exact<{
  input: CreateBulkDocumentRequestsInput;
}>;


export type CreateBulkDocumentRequestsMutation = { __typename?: 'Mutation', createBulkDocumentRequests: { __typename?: 'BulkCreateDocumentRequestsOutput', derUploadUrl?: string | null, errors: Array<{ __typename?: 'InvestisseurErrorOutput', investisseurId: any, message: string }> } };

export type CreateDocumentRequestsMutationVariables = Exact<{
  input: CreateDocumentRequestsInput;
}>;


export type CreateDocumentRequestsMutation = { __typename?: 'Mutation', createDocumentRequests: { __typename?: 'CreateDocumentRequestOutput', key?: string | null, basePath?: string | null, derUploadUrl?: string | null } };

export type DeleteDocumentRequestMutationVariables = Exact<{
  documentRequestId: Scalars['Int']['input'];
}>;


export type DeleteDocumentRequestMutation = { __typename?: 'Mutation', deleteDocumentRequest: boolean };

export type RegenerateMagicLinkMutationVariables = Exact<{
  input: RegenerateMagicLinkInput;
}>;


export type RegenerateMagicLinkMutation = { __typename?: 'Mutation', regenerateMagicLink: { __typename?: 'CreateDocumentRequestOutput', key?: string | null, basePath?: string | null } };

export type RequestInvestisseurAccountActivationMutationVariables = Exact<{
  investisseurId: Scalars['Long']['input'];
}>;


export type RequestInvestisseurAccountActivationMutation = { __typename?: 'Mutation', requestInvestisseurAccountActivation: boolean };

export type SendFollowupMailMutationVariables = Exact<{
  investisseurId: Scalars['Long']['input'];
}>;


export type SendFollowupMailMutation = { __typename?: 'Mutation', sendFollowUpMail: boolean };

export type SetInvestisseurNextAppointmentMutationVariables = Exact<{
  input: SetInvestisseurNextAppointmentInput;
}>;


export type SetInvestisseurNextAppointmentMutation = { __typename?: 'Mutation', setInvestisseurNextAppointment: boolean };

export type ValidateDocumentRequestsMutationVariables = Exact<{
  input: ValidateDocumentRequestsInput;
}>;


export type ValidateDocumentRequestsMutation = { __typename?: 'Mutation', validateDocumentRequests: { __typename?: 'ValidateDocumentRequestOutput', key?: string | null, basePath?: string | null } };

export type GetDocumentRequestCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDocumentRequestCountsQuery = { __typename?: 'Query', documentRequestCounts: { __typename?: 'DocumentRequestCountsOutput', toReview: number, waiting: number } };

export type GetDocumentRequestFilteringValuesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDocumentRequestFilteringValuesQuery = { __typename?: 'Query', documentRequestFilteringValues: { __typename?: 'DocumentRequestFilteringValuesOutput', documentStatuses: Array<DocumentStatus>, documentTypeCodes: Array<string> } };

export type GetFilteredDocumentRequestPaginatedQueryVariables = Exact<{
  searchInput: DocumentRequestSearchInput;
}>;


export type GetFilteredDocumentRequestPaginatedQuery = { __typename?: 'Query', filteredDocumentRequestPaginated: { __typename?: 'PaginatedResultOfDocumentRequestsByInvestisseurOutput', page: number, pageSize: number, totalCount: number, totalPages: number, items: Array<{ __typename?: 'DocumentRequestsByInvestisseurOutput', investisseurCode?: string | null, investisseurId: any, investisseurNom?: string | null, investisseurPrenom?: string | null, latestCreatedAt: string, magicLinkUrl?: string | null, documentRequests: Array<{ __typename?: 'DocumentRequestOutput', createdAt: string, documentTypeName?: string | null, followUpAt?: string | null, id: number, isFreeUpload: boolean, status: DocumentStatus, updatedAt?: string | null, documentUploads: Array<{ __typename?: 'DocumentUploadOutput', contentType: string, documentId: string, downloadUrl: string, id: number, fileName: string, fileExtension: string }> }> }> } };

export type GetInvestisseurDocumentRequestsForConsultantQueryVariables = Exact<{
  investisseurId: Scalars['Long']['input'];
}>;


export type GetInvestisseurDocumentRequestsForConsultantQuery = { __typename?: 'Query', investisseurDocumentRequestsForConsultant: { __typename?: 'ExternalDocumentRequestOutput', investisseurId: any, isMagicLinkExpired: boolean, magicLink?: string | null, magicLinkExpiresAt?: string | null, accountStatus?: AccountStatus | null, activatedAt?: string | null, invitedAt?: string | null, disabledAt?: string | null, connectionHistory: Array<string>, derStatus: DerStatus, nextAppointmentAt?: string | null, documentRequests: Array<{ __typename?: 'DocumentRequestOutput', createdAt: string, documentCategoryName?: string | null, documentTypeName?: string | null, followUpAt?: string | null, id: number, isFreeUpload: boolean, rejectionReason?: string | null, status: DocumentStatus, requestedTypeCodes: Array<string>, documentUploads: Array<{ __typename?: 'DocumentUploadOutput', contentType: string, createdAt: string, documentId: string, documentTypeCode?: string | null, downloadUrl: string, fileExtension: string, fileName: string, fileSize: number, id: number, order: number, side: DocumentUploadSide }> }> } };

export type PreviewDocumentEmailTemplateQueryVariables = Exact<{
  input: PreviewDocumentEmailTemplateInput;
}>;


export type PreviewDocumentEmailTemplateQuery = { __typename?: 'Query', previewDocumentEmailTemplate: { __typename?: 'EmailTemplatePreviewOutput', html?: string | null } };

export const CreateBulkDocumentRequestsDocument = gql`
    mutation createBulkDocumentRequests($input: CreateBulkDocumentRequestsInput!) {
  createBulkDocumentRequests(input: $input) {
    errors {
      investisseurId
      message
    }
    derUploadUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateBulkDocumentRequestsGQL extends Apollo.Mutation<CreateBulkDocumentRequestsMutation, CreateBulkDocumentRequestsMutationVariables> {
    override document = CreateBulkDocumentRequestsDocument;
    override client = 'myStelliumApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDocumentRequestsDocument = gql`
    mutation createDocumentRequests($input: CreateDocumentRequestsInput!) {
  createDocumentRequests(input: $input) {
    key
    basePath
    derUploadUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDocumentRequestsGQL extends Apollo.Mutation<CreateDocumentRequestsMutation, CreateDocumentRequestsMutationVariables> {
    override document = CreateDocumentRequestsDocument;
    override client = 'myStelliumApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDocumentRequestDocument = gql`
    mutation deleteDocumentRequest($documentRequestId: Int!) {
  deleteDocumentRequest(documentRequestId: $documentRequestId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDocumentRequestGQL extends Apollo.Mutation<DeleteDocumentRequestMutation, DeleteDocumentRequestMutationVariables> {
    override document = DeleteDocumentRequestDocument;
    override client = 'myStelliumApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegenerateMagicLinkDocument = gql`
    mutation regenerateMagicLink($input: RegenerateMagicLinkInput!) {
  regenerateMagicLink(input: $input) {
    key
    basePath
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegenerateMagicLinkGQL extends Apollo.Mutation<RegenerateMagicLinkMutation, RegenerateMagicLinkMutationVariables> {
    override document = RegenerateMagicLinkDocument;
    override client = 'myStelliumApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RequestInvestisseurAccountActivationDocument = gql`
    mutation requestInvestisseurAccountActivation($investisseurId: Long!) {
  requestInvestisseurAccountActivation(investisseurId: $investisseurId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RequestInvestisseurAccountActivationGQL extends Apollo.Mutation<RequestInvestisseurAccountActivationMutation, RequestInvestisseurAccountActivationMutationVariables> {
    override document = RequestInvestisseurAccountActivationDocument;
    override client = 'myStelliumApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendFollowupMailDocument = gql`
    mutation sendFollowupMail($investisseurId: Long!) {
  sendFollowUpMail(investisseurId: $investisseurId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendFollowupMailGQL extends Apollo.Mutation<SendFollowupMailMutation, SendFollowupMailMutationVariables> {
    override document = SendFollowupMailDocument;
    override client = 'myStelliumApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetInvestisseurNextAppointmentDocument = gql`
    mutation setInvestisseurNextAppointment($input: SetInvestisseurNextAppointmentInput!) {
  setInvestisseurNextAppointment(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetInvestisseurNextAppointmentGQL extends Apollo.Mutation<SetInvestisseurNextAppointmentMutation, SetInvestisseurNextAppointmentMutationVariables> {
    override document = SetInvestisseurNextAppointmentDocument;
    override client = 'myStelliumApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ValidateDocumentRequestsDocument = gql`
    mutation validateDocumentRequests($input: ValidateDocumentRequestsInput!) {
  validateDocumentRequests(input: $input) {
    key
    basePath
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ValidateDocumentRequestsGQL extends Apollo.Mutation<ValidateDocumentRequestsMutation, ValidateDocumentRequestsMutationVariables> {
    override document = ValidateDocumentRequestsDocument;
    override client = 'myStelliumApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDocumentRequestCountsDocument = gql`
    query getDocumentRequestCounts {
  documentRequestCounts {
    toReview
    waiting
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDocumentRequestCountsGQL extends Apollo.Query<GetDocumentRequestCountsQuery, GetDocumentRequestCountsQueryVariables> {
    override document = GetDocumentRequestCountsDocument;
    override client = 'myStelliumApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDocumentRequestFilteringValuesDocument = gql`
    query getDocumentRequestFilteringValues {
  documentRequestFilteringValues {
    documentStatuses
    documentTypeCodes
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDocumentRequestFilteringValuesGQL extends Apollo.Query<GetDocumentRequestFilteringValuesQuery, GetDocumentRequestFilteringValuesQueryVariables> {
    override document = GetDocumentRequestFilteringValuesDocument;
    override client = 'myStelliumApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFilteredDocumentRequestPaginatedDocument = gql`
    query getFilteredDocumentRequestPaginated($searchInput: DocumentRequestSearchInput!) {
  filteredDocumentRequestPaginated(searchInput: $searchInput) {
    page
    pageSize
    totalCount
    totalPages
    items {
      investisseurCode
      investisseurId
      investisseurNom
      investisseurPrenom
      latestCreatedAt
      documentRequests {
        createdAt
        documentTypeName
        followUpAt
        id
        isFreeUpload
        status
        updatedAt
        documentUploads {
          contentType
          documentId
          downloadUrl
          id
          fileName
          fileExtension
        }
      }
      magicLinkUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFilteredDocumentRequestPaginatedGQL extends Apollo.Query<GetFilteredDocumentRequestPaginatedQuery, GetFilteredDocumentRequestPaginatedQueryVariables> {
    override document = GetFilteredDocumentRequestPaginatedDocument;
    override client = 'myStelliumApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetInvestisseurDocumentRequestsForConsultantDocument = gql`
    query getInvestisseurDocumentRequestsForConsultant($investisseurId: Long!) {
  investisseurDocumentRequestsForConsultant(investisseurId: $investisseurId) {
    investisseurId
    isMagicLinkExpired
    magicLink
    magicLinkExpiresAt
    accountStatus
    activatedAt
    invitedAt
    disabledAt
    connectionHistory
    derStatus
    nextAppointmentAt
    documentRequests {
      createdAt
      documentCategoryName
      documentTypeName
      followUpAt
      id
      isFreeUpload
      rejectionReason
      status
      requestedTypeCodes
      documentUploads {
        contentType
        createdAt
        documentId
        documentTypeCode
        downloadUrl
        fileExtension
        fileName
        fileSize
        id
        order
        side
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInvestisseurDocumentRequestsForConsultantGQL extends Apollo.Query<GetInvestisseurDocumentRequestsForConsultantQuery, GetInvestisseurDocumentRequestsForConsultantQueryVariables> {
    override document = GetInvestisseurDocumentRequestsForConsultantDocument;
    override client = 'myStelliumApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PreviewDocumentEmailTemplateDocument = gql`
    query previewDocumentEmailTemplate($input: PreviewDocumentEmailTemplateInput!) {
  previewDocumentEmailTemplate(input: $input) {
    html
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PreviewDocumentEmailTemplateGQL extends Apollo.Query<PreviewDocumentEmailTemplateQuery, PreviewDocumentEmailTemplateQueryVariables> {
    override document = PreviewDocumentEmailTemplateDocument;
    override client = 'myStelliumApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }